import { render, staticRenderFns } from "./croplandactions.vue?vue&type=template&id=c79e165c&"
import script from "./croplandactions.vue?vue&type=script&lang=js&"
export * from "./croplandactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports